<template>
    <main class="main-signin text-center">
        <template v-if="auth">
            <template v-if="paymentShow">
                <div class="alert mb-3" :class="paymentSuccess ? 'alert-success' : 'alert-light'" role="alert">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                        
                        <template v-if="!paymentSuccess">

                            <template v-for="(item, index) in qrcodes">
                                
                                <div :key="'qr-title-' + index" class="w-100 mt-3" v-if="qrcodes.length > 1">
                                    <h5 class="font-weight-bold">Cobrança {{ index + 1 }} de {{ qrcodes.length }}</h5>
                                    <h6 class="mb-2">Valor: <strong>{{ item.valor | formatCoin }}</strong></h6>
                                </div>

                                <div :key="'qr-paid-' + index" v-if="item.status === 'paid'" class="p-3 mb-3 w-100 bg-success text-white rounded">
                                    <h3><i class="fas fa-check-circle"></i></h3>
                                    <span class="font-weight-bold">Este QR Code já foi pago!</span>
                                </div>

                                <template v-else>
                                    <div :key="'qr-img-' + index" class="text-center mb-3">
                                        <img class="rounded" :src="item.qrcode.image" width="225" height="225" border="0" alt="QR Code">
                                    </div>
                                    
                                    <span :key="'qr-span-' + index">
                                        Escanei o <b>QR Code</b> com o app do seu banco ou {{ platform == 'desktop' ? 'clique' : 'aperte' }} no campo abaixo para copiar o código do pix.
                                    </span>
                                    
                                    <div class="input-group mt-3" :key="'qr-inp-' + index">
                                        <div class="input-group-prepend" role="button" @click="copyClipboard(index)">
                                            <span class="input-group-text" id="inputGroupPrepend3">
                                                <i class="fas fa-copy mr-2"></i>Copiar
                                            </span>
                                        </div>
                                        <input class="form-control" id="input-pix" ref="pix-qrcode" type="text" :value="item.qrcode.code" autocomplete="off" spellcheck="false" readonly>
                                    </div>
                                </template>

                                <hr :key="'qr-hr-' + index" v-if="index < qrcodes.length - 1" class="w-100" />
                            
                            </template>

                            <hr />
                            <p class="mb-0">Tentativas: <strong>{{ pay_total_check_count }}/{{ pay_total_check_limit }}</strong></p>
                            <p class="mb-0">Status geral: <strong>Aguardando pagamento...</strong></p>
                            <p v-if="qrcodes.length > 1" class="small text-muted">
                                **{{ total_payment_success }} de {{ qrcodes.length }} pagamentos confirmados.**
                            </p>
                        
                        </template>

                        <template v-else>
                            <div class="display-3">
                                <i class="fas fa-badge-check"></i>
                            </div>
                            <div class="font-weight-bold">{{ company }}</div>
                            <div>Recebemos seu pagamento integral!</div>
                            <div class="w-100 mt-2">
                                <button class="btn btn-block btn-warning" @click="reload">Sair</button>
                            </div>
                        </template>

                    </div>
                </div>
            </template>
            
            <template v-else>
                <form class="form-signin" @submit.prevent="generatePayment">
                    <h1 class="h3 mb-3 font-weight-normal">
                        {{ edit && action == 'edit' ? 'Alterar dados' : 'Gerar pagamento' }}
                    </h1>
                    <div class="alert alert-warning" role="alert">
                        <div>Olá, <strong>{{ company }}</strong>.</div>
                        <hr />
                        <div class="row">
                            <div class="col text-left">Valor</div>
                            <div class="col text-right">{{ men_value | formatCoin }}</div>
                        </div>
                        <div class="row">
                            <div class="col text-left">Data de pag.</div>
                            <div class="col text-right">{{ men_date | formatDate }}</div>
                        </div>
                    </div>
                    <label for="inputName" class="sr-only">Nome completo</label>
                    <input type="text" id="inputName" v-model="name" class="form-control" placeholder="Nome completo" autocomplete="off" spellcheck="false" required autofocus :readonly="!edit">
                    <label for="inputDocument" class="sr-only">CPF (Apenas números)</label>
                    <input type="text" id="inputDocument" v-model="document" class="form-control" placeholder="CPF (Apenas números)" autocomplete="off" spellcheck="false" maxlength="11" required autofocus :readonly="!edit">
                    <template v-if="edit">
                        <label for="inputCep" class="sr-only">CEP</label>
                        <input type="text" id="inputCep" v-model="client_cep" class="form-control" placeholder="CEP" autocomplete="off" spellcheck="false" maxlength="9" required>
                        <label for="inputState" class="sr-only">Estado</label>
                        <input type="text" id="inputState" v-model="client_state" class="form-control" placeholder="Estado" autocomplete="off" spellcheck="false" :readonly="!viaCepError" required>
                        <label for="inputCity" class="sr-only">Cidade</label>
                        <input type="text" id="inputCity" v-model="client_city" class="form-control" placeholder="Cidade" autocomplete="off" spellcheck="false" :readonly="!viaCepError" required>
                        <label for="inputAddress" class="sr-only">Endereço</label>
                        <input type="text" id="inputAddress" v-model="client_address" class="form-control" placeholder="Endereço (Ex: Rua tal, número 12)" autocomplete="off" spellcheck="false" required>
                    </template>
                    <button class="btn btn-lg btn-warning btn-block" type="submit">
                        <i class="fas fa-check-circle mr-2"></i>{{ edit && !action ? 'Salvar e gerar' : edit && action ? 'Salvar alterações' : 'Gerar' }}
                    </button>
                </form>
            </template>
        </template>
        
        <template v-else>
            <form class="form-signin" @submit.prevent="authentication">
                <h1 class="h3 mb-3 font-weight-normal">Autenticação</h1>
                <label for="inputPassword" class="sr-only">PIN</label>
                <input type="password" id="inputPassword" v-model="pin" class="form-control" placeholder="PIN" autocomplete="off" spellcheck="false" required autofocus>
                <button class="btn btn-lg btn-warning btn-block" type="submit">
                    <i class="fas fa-sign-in-alt mr-2"></i>Entrar
                </button>
            </form>
        </template>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import {api} from '../api'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment-timezone'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    data() {
        return {
            pin: '',
            name: '',
            pay_id: '', 
            company: '',
            men_date: '',
            men_value: '',
            document: '',
            client_id: '',
            client_name: '',
            client_document: '',
            client_address: '',
            client_city: '',
            client_state: '',
            client_cep: '',
            edit: false,
            viaCepError: false,
            paymentShow: false,
            paymentSuccess: false,
            pay_status: 'pending',
            pay_total_check_count: 0,
            pay_total_check_limit: 50,
            qrcodes: [], // MODIFICADO: Array para armazenar 1 ou mais QRCodes/Cobranças
            total_payment_success: 0, // NOVO: Contagem de pagamentos individuais confirmados
            action: '',
            auth: false,
            loading: false,
            autoAuth: false,
            network_erros: {
                0: { message: 'Não há conexão com a internet!' },
                401: { message: 'Você não tem autorização para realizar essa operação!' },
                404: { message: 'Página solicitada não foi encontrada!' },
                500: { message: 'O servidor está passando por problemas técnicos!' },
                408: { message: 'Por favor, verifique sua conexão de rede e tente novamente!' }                
            },
            platform: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
        }
    },
    components: { Loading },
    methods: {
        authentication() {

            const self = this;

            if (self.pin.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o PIN de acesso!',
                    'warning'
                );
            } else {

                self.loading = true;

                api.post('auth', {
                    pin: self.pin
                }).then((response) => {
                    switch(response.data.result) {
                        case 'success':
                            self.auth = true;
                            self.company = response.data.company;
                            self.men_date = response.data.men_date;
                            self.men_value = response.data.men_value;
                            self.client_id = response.data.client_id;
                            self.client_name = response.data.client_name;
                            self.client_cep = response.data.client_cep;
                            self.client_city = response.data.client_city;
                            self.client_state = response.data.client_state; 
                            self.client_address = response.data.client_address;
                            self.client_document = response.data.client_document;
                        break;
                        default:
                            Swal.fire(
                                'Atenção!',
                                response.data.message,
                                'warning'
                            );
                        break;
                    }
                }).catch((error) => {
                    try {
                        Swal.fire(
                            'Falha',
                            self.network_erros[error.status]['message'],
                            'warning'
                        );
                    } catch(e) {
                        Swal.fire(
                            'Falha',
                            self.network_erros[408]['message'],
                            'warning'
                        );
                    }
                }).finally(() => {
                    self.loading = false;
                });
            }
        },
        generatePayment() {

            const self = this;

            if (self.client_id == '') {
                window.location.reload();
            } else if (self.name.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe seu nome completo!',
                    'warning'
                );
            } else if (self.document.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe seu CPF!',
                    'warning'
                );
            } else if (self.edit && self.client_cep.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe seuCEP!',
                    'warning'
                );
            } else if (self.edit && self.client_state.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe seu estado!',
                    'warning'
                );
            } else if (self.edit && self.client_city.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe sua cidade!',
                    'warning'
                );
            } else if (self.edit && self.client_address.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe seu endereço!',
                    'warning'
                );
            } else if (self.action == 'edit') {
                self.accountEdit();
            } else {

                // Resetando os dados
                self.pay_id = '';
                self.loading = true;
                self.qrcodes = []; 
                self.paymentShow = false;
                self.pay_status = 'pending';
                self.pay_total_check_count = 0;
                self.total_payment_success = 0;

                api.post('generate-payment', {
                    client_name: self.name,
                    client_id: self.client_id,
                    client_document: self.document,
                    client_cep: self.client_cep,
                    client_city: self.client_city,
                    client_state: self.client_state,
                    client_address: self.client_address,
                }).then((response) => {
                    
                    let qrcodesTemp = [];

                    if (response.data.result === 'success') {
                        // Resposta ÚNICA (Padroniza para array)
                        self.pay_id = response.data.pay_id;
                        qrcodesTemp = [{
                            pay_id: response.data.pay_id,
                            valor: response.data?.valor || self.men_value,
                            qrcode: response.data.qrcode
                        }];
                    } else if (response.data.result === 'success_multiple') {
                        // Resposta MÚLTIPLA
                        self.pay_id = response.data.cobrancas[0].pay_id; // Pega o primeiro ID
                        qrcodesTemp = response.data.cobrancas;
                    } else {
                        Swal.fire('Atenção!', response.data.message, 'warning');
                        return;
                    }

                    // Adiciona status 'pending' em todos antes de salvar no data
                    self.qrcodes = qrcodesTemp.map(item => ({
                        ...item,
                        status: 'pending' 
                    }));
                    
                    self.paymentShow = true;

                }).catch((error) => {
                    try {
                        Swal.fire(
                            'Falha',
                            self.network_erros[error.status]['message'],
                            'warning'
                        );
                    } catch(e) {
                        Swal.fire(
                            'Falha',
                            self.network_erros[408]['message'],
                            'warning'
                        );
                    }
                }).finally(() => {
                    self.loading = false;
                });
            }
        },
        accountEdit() {

            const self = this;

            if (self.name.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o seu nome!',
                    'warning'
                );
            } else if (self.document.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o seu CPF!',
                    'warning'
                );
            } else if (self.client_cep.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o CEP!',
                    'warning'
                );
            } else if (self.client_city.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o sua cidade!',
                    'warning'
                );
            } else if (self.client_state.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o seu estado!',
                    'warning'
                );
            } else if (self.client_address.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o seu endereço!',
                    'warning'
                );
            } else {

                self.loading = true;

                api.post('edit-account', {
                    pin: self.pin,
                    client_name: self.name,
                    client_id: self.client_id,
                    client_document: self.document,
                    client_cep: self.client_cep,
                    client_city: self.client_city,
                    client_state: self.client_state,
                    client_address: self.client_address,
                }).then((response) => {
                    switch(response.data.result) {
                        case 'success':
                            Swal.fire({
                                title: 'Pagamento da adesão',
                                html: 'Você deseja prosseguir para o pagamento da adesão?',
                                showCancelButton: true,
                                confirmButtonColor: '#28a745',
                                cancelButtonColor: '#d33',
                                cancelButtonText: 'Não',
                                confirmButtonText: 'Sim'
                            }).then((result) => {
                                if (result.value) {
                                    window.location.href = `https://payment.betsnow.net/pay?pin=${response.data.pin}`;
                                } else {
                                    Swal.fire(
                                        'Parabéns!',
                                        'Suas alterações foram salvas com sucesso!',
                                        'success'
                                    );
                                }
                            });
                        break;
                        default:
                            Swal.fire(
                                'Atenção!',
                                response.data.message,
                                'warning'
                            );
                        break;
                    }
                }).catch((error) => {
                    try {
                        Swal.fire(
                            'Falha',
                            self.network_erros[error.status]['message'],
                            'warning'
                        );
                    } catch(e) {
                        Swal.fire(
                            'Falha',
                            self.network_erros[408]['message'],
                            'warning'
                        );
                    }
                }).finally(() => {
                    self.loading = false;
                });
            }
        },
        checkPaymentPix() {
            const self = this;
            if (!self.client_id) return;

            api.post('check-payment-status', {
                pay_id: self.pay_id,
                client_id: self.client_id
            }).then((response) => {
                self.checkPaymentStatus(response.data); 
            }).catch((error) => {
                try {
                    Swal.fire(
                        'Falha',
                        self.network_erros[error.status]['message'],
                        'warning'
                    );
                } catch(e) {
                    Swal.fire(
                        'Falha',
                        self.network_erros[408]['message'],
                        'warning'
                    );
                }
            });
        },
        
        checkPaymentStatus(data) {
            this.pay_total_check_count += 1;
            
            // 1. Atualiza o status individual de cada QR Code
            let successCount = 0;
            // O backend deve retornar 'paid_ids' mesmo que o status geral seja 'pending'
            if (data.paid_ids && Array.isArray(data.paid_ids)) {
                
                // Mapeia e atualiza o array de forma reativa
                this.qrcodes = this.qrcodes.map(qr => {
                    if (data.paid_ids.includes(qr.pay_id)) {
                        qr.status = 'paid';
                        successCount++;
                    }
                    return qr;
                });
                
                this.total_payment_success = successCount;
            }

            // 2. Lógica de Decisão (Sucesso total ou Pendente)
            if (data.result == 'success') {
                // SUCESSO TOTAL
                this.pay_id = '';
                this.paymentSuccess = true;
                this.pay_status = 'approved';
                this.pay_total_check_count = 0;
                this.total_payment_success = this.qrcodes.length;

            } else if (data.result == 'pending') {
                // PENDENTE (Continua verificando se não estourou o limite)
                if (this.pay_total_check_count <= this.pay_total_check_limit) {
                    setTimeout(this.checkPaymentPix, 5000);
                }
            }
        },

        copyClipboard(index) {
            try {
                // Usa o index para pegar o input correto do array de refs
                navigator.clipboard.writeText(this.$refs['pix-qrcode'][index]['value']).then(() => {
                    Swal.fire(
                        'Parabéns',
                        'O <strong>código</strong> foi copiado com sucesso!',
                        'success'
                    );
                }, () => {
                    Swal.fire(
                        'Atenção',
                        'Não foi possível copiar o <strong>link</strong>!',
                        'warning'
                    );
                });
            } catch(e) {
                Swal.fire(
                    'Falha',
                    'Ocorreu um erro, atualize a página e tente novamente!',
                    'error'
                );
            }
        },
        
        checkCep(cep) {

            const self = this;
            const nCep = cep.replace(/[^0-9]/g, '');

            if (nCep) {

                self.loading = true;
                self.viaCepError = false;

                axios.get(`https://viacep.com.br/ws/${nCep}/json`).then((response) => {
                    if (!response.data.erro) {
                        self.client_state = response.data.estado;
                        self.client_city = response.data.localidade;
                    } else {
                        self.viaCepError = true;
                        Swal.fire(
                            'Falha',
                            'O CEP informado não foi encontrado ou não é válido!',
                            'error'
                        );
                    }
                }).catch((error) => {
                    try {
                        Swal.fire(
                            'Falha',
                            self.network_erros[error.status]['message'],
                            'warning'
                        );
                    } catch(e) {
                        Swal.fire(
                            'Falha',
                            self.network_erros[408]['message'],
                            'warning'
                        );
                    }
                }).finally(() => {
                    self.loading = false;
                });
            } else {
                Swal.fire(
                    'Falha',
                    'Você não informou o CEP!',
                    'error'
                );
            }
        },
        reload() {
            window.location.reload();
        }
    },
    beforeMount() {
        document.title = 'BNOW - Pagamento';
    },
    watch: {
        name(value) {
            return this.name = value.replace(/[^a-zà-ú\s]+/gi, '');
        },
        pin(value) {
            return this.pin = value.replace(/[^a-zA-Z0-9]/g, '');
        },
        document(value) {
            return this.document = value.replace(/[^0-9]/g, '');
        },
        client_name(value) {
            this.name = value;
        },
        client_document(value) {
            this.document = value;
        },
        client_cep(value) {
            if (!value) return "";
            value = value.replace(/\D/g,'');
            value = value.replace(/(\d{5})(\d)/,'$1-$2');
            if (value.toString().length == 9) this.checkCep(value);
            return this.client_cep = value;
        },
        autoAuth(value) {
            if (value) {
                setTimeout(() => {
                    this.authentication();
                }, 100);
            }
        },
        paymentShow(value) {
            if (value) {
                this.checkPaymentPix();
            }
        }
    },
    filters: {
        formatDate(value) {
            return moment(value).format('DD/MM/YYYY');
        },
        formatCoin(n, c, d, t, s, i, j) {
            c = isNaN(c = Math.abs(c)) ? 2 : c, d = d == undefined ? "," : d, t = t == undefined ? "." : t, s = n < 0 ? "-" : "", i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        }
    },
    created() {
        if (this.$route.query['pin'] != undefined) {
            this.pin = this.$route.query.pin;
            this.autoAuth = true;
        }
        if (this.$route.query['edit'] != undefined) {
            this.edit = this.$route.query.edit === 'true';
        }
        if (this.$route.query['action'] == 'edit') {
            this.action = 'edit';
        }
    }
}
</script>

<style scoped>
.main-signin {
  height: 100vh;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
  /* Garante que o scroll funcione com múltiplos QRCodes */
  height: auto;
  min-height: 100vh;
}
.alert:not(.alert-warning) {
    width: 400px;
}
.form-signin {
  width: 100%;
  max-width: 400px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
}
.form-signin input:not(:first-of-type) {
  margin: 10px 0;
}
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .form-signin {
    max-width: 100%;
  }
  .alert:not(.alert-warning) {
    width: 100%;
    margin: 0 1em;
  }
}
</style>